import './scss/main.scss'
import gsap from "gsap";
import FontFaceObserver from 'fontfaceobserver';
const tl = gsap.timeline()

const SilentReaction = new Promise(resolve => {
    new FontFaceObserver("Silent-Reaction").load().then(() => {
        resolve()
    });
})

const inputSans = new Promise(resolve => {
    new FontFaceObserver("input-sans").load().then(() => {
        resolve()
    });
})

const linotypeSabon = new Promise(resolve => {
    new FontFaceObserver("linotype-sabon").load().then(() => {
        resolve()
    });
})

let allDone = [SilentReaction, inputSans, linotypeSabon];
const body = document.body
const loadingBG = document.getElementById("loading_bg")
const topHeadline = document.querySelector(".Top_Headline h1") // about page titel
const introImg = document.querySelector(".Intro_Img")
const leadText = document.querySelector(".Intro_Desc .Lead_txt")
const description = document.querySelector(".Intro_Desc .desc")
const aboutImg01 = document.querySelector(".aboutImg01")
const aboutImg02 = document.querySelector(".aboutImg02")
const easing = "cubic-bezier(0, 0.55, 0.45, 1)"
const easing02 = "cubic-bezier(0.5, 1.4, 0.5, 1)"

const Home_fvAnimation = () => {
    gsap.set(topHeadline, { y: 30 })
    gsap.set(introImg, { y: 40, opacity: 0, scale: 2 })
    gsap.set(leadText, { y: 30, opacity: 0 })
    gsap.set(description, { y: 30, opacity: 0 })

    tl.to(introImg, {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: easing
    })
        .to(topHeadline, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: easing02
        }, "-=0.1")
        .to(leadText, {
            y: 0,
            opacity: 1,
            duration: 0.7,
            ease: easing02
        }, "-=0.65")
        .to(description, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: easing02
        }, "-=0.55")
}

const About_fvAnimation = () => {
    if (aboutImg01) {
        gsap.set(topHeadline, { y: 60 })
        gsap.set(aboutImg01, { y: 40 })
        gsap.set(aboutImg02, { y: 40 })

        tl.to(topHeadline, {
            y: 0,
            opacity: 1,
            duration: 0.4,
            ease: easing
        })
            .to(aboutImg01, {
                y: 0,
                opacity: 1,
                duration: 0.7,
                ease: easing
            }, "-=1.1")
            .to(aboutImg02, {
                y: 0,
                opacity: 1,
                duration: 0.7,
                ease: easing
            }, "-=1")
    }
}

const fvLoading = () => {
    body.classList.remove('loading')
    loadingBG.classList.add('loaded')
}

Promise.all(allDone).then(() => {
    fvLoading()
})
    .then(() => {
        Home_fvAnimation()
        About_fvAnimation()
    })


const menuBtn = document.querySelector('.mb_Menu_Btn')
const links = [...document.querySelectorAll('nav li a[href^="#"]')]
const nav = document.querySelector('nav')
menuBtn.addEventListener('click', (e) => {
    e.preventDefault()
    nav.dataset.mbNav = nav.dataset.mbNav === 'close' ? 'open' : 'close'
    if (nav.dataset.mbNav === 'open') {
        menuBtn.setAttribute("aria-expanded", "true")
    } else {
        menuBtn.setAttribute("aria-expanded", "false")
    }
})

if (isMobile()) {
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            nav.dataset.mbNav = nav.dataset.mbNav === 'open' ? 'close' : 'open'
        })
    })
}

function isMobile() {
    const userAgent = navigator.userAgent.toLowerCase()
    const mobileKeywords = ['webos', 'iphone', 'ipod', 'ipad', 'android', 'blackberry', 'windows phone', 'opera mini', 'IEMobile']
    for (let keyword of mobileKeywords) {
        if (userAgent.indexOf(keyword) !== -1) {
            return true;
        }
    }
    return false;
}
isMobile()


function isInViewport(element) {
    const rect = element.getBoundingClientRect()
    const windowHeight = window.innerHeight || document.documentElement.clientHeight
    const triggerHeight = windowHeight * 0.4
    return (
        rect.top >= -triggerHeight &&
        rect.bottom <= (windowHeight + triggerHeight)
    );
}


const generalResizeFunc = () => {
    window.addEventListener("resize", () => {
        let timeoutID = 0
        let delay = 1000

        // Keep clearing the process while resizing.
        clearTimeout(timeoutID)

        timeoutID = setTimeout(() => {
            isMobile()
        }, delay)
    }, false);
}
generalResizeFunc()


/**
 * Intersection Observer
 */
const targets = document.querySelectorAll("[data-animation]");
const options = {
    root: null,
    rootMargin: "-5% 0px",
    threshold: 0
};
const observer = new IntersectionObserver(animationStart, options);

targets.forEach(tar => {
    observer.observe(tar)
});

function animationStart(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            let animaItem = entry.target
            animaItem.dataset.animation = 'true'
            observer.unobserve(animaItem)
        }
    });
}


/**
 * Hand writing animation
 */
const getStrokLength = (ele) => {
    if (!Array.isArray(ele)) {
        let length = ele.getTotalLength()
        ele.style.strokeDasharray = length + ' ' + length
        ele.style.strokeDashoffset = length
    } else {
        ele.forEach(e => {
            let length = e.getTotalLength()
            e.style.strokeDasharray = length + ' ' + length
            e.style.strokeDashoffset = length
        });
    }
}

const svgAnimation = (elements) => {
    if (!Array.isArray(elements)) {
        elements = [elements]
        getStrokLength(elements)
        elements.classList.add('animated')
    } else {
        elements.forEach(sub => {
            getStrokLength(sub)
            sub.classList.add('animated')
        });
    }
}


const scrollToPagetop = () => {
    window.onload = function () {
        window.scrollTo(0, 0)
    }
}
scrollToPagetop()


function anchorLink() {
    if (isMobile()) {
        const worksContainer = document.getElementById("works")

        if (!worksContainer) {
            return
        } else {
            const urlHash = window.location.hash
            const worksID = worksContainer.getAttribute('id')
            const top = worksContainer.getBoundingClientRect().top
            const viewportTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
            if (urlHash.indexOf(`${worksID}`) !== -1) {
                let delay = 100

                setTimeout(() => {
                    const scrollToPosition = viewportTop + top
                    window.scrollTo(0, scrollToPosition)
                }, delay)
            }
        }
    }
}
window.addEventListener('load', anchorLink())


/**
 * Update copyright's year
 */
const copyrightYear = document.getElementById("year")
copyrightYear.textContent = new Date().getFullYear()

export { isMobile, isInViewport, generalResizeFunc, svgAnimation }